import { createIcon } from './create-icon';

export const EyeOffIcon = createIcon(
  'EyeOffIcon',
  <>
    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
    <path d="M6.61 6.61A13.53 13.53 0 001 12s4 8 11 8a9.74 9.74 0 005.39-1.61" />
    <path d="M14.12 14.12a3 3 0 11-4.24-4.24" />
    <path d="M1 1l22 22" />
  </>,
);
